import { SharedConstants } from "../../../../shared/constants/shared.constants";
export var ArcGisItmHeadingEnum;
(function (ArcGisItmHeadingEnum) {
    ArcGisItmHeadingEnum["name"] = "Name";
    ArcGisItmHeadingEnum["category"] = "Category";
    ArcGisItmHeadingEnum["url"] = "Url";
    ArcGisItmHeadingEnum["disabled"] = "Disabled";
    ArcGisItmHeadingEnum["onlyShowInWorkflow"] = "Only show in workflow";
})(ArcGisItmHeadingEnum || (ArcGisItmHeadingEnum = {}));
export const ArcGisItmHeadingEnumLookup = new Map([
    [ArcGisItmHeadingEnum.name, "name"],
    [ArcGisItmHeadingEnum.category, "category"],
    [ArcGisItmHeadingEnum.onlyShowInWorkflow, "onlyShowInWorkflowLabel"],
    [ArcGisItmHeadingEnum.disabled, "disabledLabel"],
]);
export class ArcgisItemConstants {
    static DELETE_ITEM_TITLE = "Delete ArcGIS item";
    static DELETE_ARC_GIS_ITEM_CONFIRM = SharedConstants.REMOVE_MESSAGE + " ArcGIS item(s)?";
    static NAME_TEXT = "Name";
    static NAME_CONTROL = "name";
    static URL_CONTROL = "url";
    static URL_TEXT = "Url";
    static CATEGORY_CONTROL = "category";
    static CATEGORY_TEXT = "Category";
    static AUTH_TYPE_CONTROL = "authType";
    static AUTH_TYPE_TEXT = "Authentication type";
    static CLIENT_ID_CONTROL = "clientId";
    static CLIENT_ID_TEXT = "Client Id";
    static SECRET_CONTROL = "secret";
    static SECRET_TEXT = "Secret";
    static USERNAME_CONTROL = "username";
    static USERNAME_TEXT = "User name";
    static PASSWORD_CONTROL = "password";
    static PASSWORD_TEXT = "Password";
    static DISABLE_CONTROL = "disabled";
    static DISABLE_TEXT = "Disabled";
    static PARAMETERS_CONTROL = "systemArcgisItemParameters";
    static PARAMETERS__TEXT = "Parameters";
    static IS_AUTHENTICATED_CONTROL = "isAuth";
    static IS_AUTHENTICATED_TEXT = "Service is authenticated";
    static SELECTION_LAYER_CONTROL = "selectionLayerType";
    static DEFAULT_VISIBILITY_CONTROL = "defaultVisibility";
    static SHOW_POPUPS_CONTROL = "showPopups";
    static SELECTION_LAYER_TEXT = "Selection layer";
    static DEFAULT_VISIBILITY_TEXT = "Default visibility";
    static SHOW_POPUPS_TEXT = "Show popups";
    static ONLY_SHOW_IN_WORKFLOW_TEXT = "Only show in workflow";
    static ONLY_SHOW_IN_WORKFLOW_CONTROL = "onlyShowInWorkflow";
    static CLIENT_ID_FORM_PLACEHOLDER = "e.g. 1234";
    static SECRET_FORM_PLACEHOLDER = "e.g. xxxx";
    static USERNAME_FORM_PLACEHOLDER = "e.g. John117";
    static PASSWORD_FORM_PLACEHOLDER = "e.g. xxxx";
    static ARCGIS_ITEM_TITLE = "ArcGIS items";
    static ADD_ARCGIS_ITEM_TITLE = "Add ArcGIS item";
    static EDIT_ARCGIS_ITEM_TITLE = "Edit ArcGIS item";
    static DUPLICATE_NAME_MESSAGE = "An item with the provided name already exists. Please supply a new name.";
    static DUPLICATE_URL_MESSAGE = "An item with the provided url already exists, Please supply a new url.";
    static INVALID_ESRI_URL = "Url not a valid Esri endpoint";
    static INVALID_ESRI_AUTH = "ArcGis item authentication failed";
    static LOOKUP_NAME = "ArcGISItemType";
    static URL_FORM_PLACEHOLDER = "e.g.https://sampleserver.arcgisonline.com/ArcGIS/rest/services/Townplanning/arcgisItems";
    static AGOL = "Agol";
    static PORTAL = "Portal";
    static PORTAL_OAUTH = "Portal OAuth";
    static SERVER = "Server";
}
export const arcGisValidationMessage = {
    url: {
        required: `Url ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        pattern: "Not a valid url format"
    },
    name: {
        required: `Name ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
        maxLength: `Name ${SharedConstants.MAX_LENGTH_INPUT_CONTROL_VALIDATION.replace("yyy", "150")}`
    },
    authType: {
        required: `Authentication Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    clientId: {
        required: `Client Id ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    secret: {
        required: `Secret ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    username: {
        required: `Username ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    password: {
        required: `Password ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
    selectionLayerType: {
        required: `Selection Layer Type ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`,
    },
};
